export default __webpack_public_path__ + "static/media/enquiry.765c0914.jpeg";